import {
  Alert,
  Box,
  Card,
  CardContent,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { StudentRoutes } from "config/routes";
import { Link as LinkBase } from "react-router-dom";
import { FC } from "react";
import { CoachPetAvatar } from "components/VetStore/CoachPetAvatar";

type MentorsProps = {
  data: any;
};

export const Mentors: FC<MentorsProps> = ({ data }) => {
  return (
    <Card>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" gutterBottom>
            Mentors
          </Typography>
          <Link
            sx={{ textDecoration: "none" }}
            component={LinkBase}
            to={StudentRoutes.MentorList}
          >
            MANAGE MENTORS
          </Link>
        </Box>
        {data?.mentors?.length > 0 && (
          <Stack direction="column" spacing={2}>
            {data.mentors.map((mentor: any) => (
              <Stack
                key={mentor.user_id}
                direction="row"
                spacing={2}
                alignItems="center"
              >
                <CoachPetAvatar
                  pictureUrl={mentor.picture_url}
                  name={mentor.name}
                  equippedStoreItems={mentor.equipped_store_items}
                />
                <Stack direction="column" spacing={0}>
                  <Typography>{mentor.name}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {mentor.email}
                  </Typography>
                </Stack>
              </Stack>
            ))}
          </Stack>
        )}
        {data?.mentors?.length === 0 && (
          <Alert severity="info">You don't have any mentors yet.</Alert>
        )}
      </CardContent>
    </Card>
  );
};
